import React from "react"
import { Link } from "gatsby"

import Pill from "~components/Pill"
import { VERBS } from '../../../utils/sort'
import * as style from "./Sidebar.module.scss"

const SidebarEndpoint = ({
  endpoint, location, className = '', microcopy,
}) => {
  const withPill = endpoint.stabilityLevel === "beta"

  return (
    <Link
      className={`${style.link} ${className}`}
      to={endpoint.path}
      data-verb-pill={withPill}
    >
      <Pill
        pillType="pillSmall"
        text={VERBS[endpoint.verb]}
        className={`${style.verb} ${style[`verb_${endpoint.verb}`]}`}
        aria-hidden
      />
      <p>
        {endpoint.title}
      </p>
      {withPill
          && (
          <Pill
            pillType="pillSmall"
            text={microcopy.text("reference.pill.beta")}
            color="blue"
            className={style.endpointPill}
          />
          )}
    </Link>

  )
}

export default SidebarEndpoint
